import React from 'react'
import HeaderFour from '../header/HeaderFour';
import BreadcrumbBlog from '../inner/breadcrumb/BreadcrumbBlog';
import Footer from '../elements/Footer';
import { Link } from 'react-router-dom';
import Blog from '../home/Blog';
import HeaderNew from '../header/HeaderNew';



function ServiceDetails() {
  return (
    <div className='service-details'>
      <HeaderNew />
      <main>
        {/* <BreadcrumbBlog/> */}
        <div className="my-5 pt-5">
          <Blog />
        </div>
        <Footer />
      </main>
    </div>
  )
}

export default ServiceDetails